module.exports = __webpack_public_path__ + "d64435a806e0b74a5071922544a1129a.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/gewonnen_level_1_opgewekt.mp3
// module id = 183
// module chunks = 0